import { WalletCategory } from "./enums";

export const WalletCategoryText = Object.freeze({
  [WalletCategory.SystemReceive]: "系統收款",
  [WalletCategory.SystemCollect]: "系統歸集",
  [WalletCategory.SystemExpend]: "系統雜支",
  [WalletCategory.ProviderReceive]: "系統商收款",
  [WalletCategory.ProviderCollect]: "系統商歸集",
  [WalletCategory.ProviderExpend]: "系統商雜支",
  [WalletCategory.OperatorReceive]: "營運商收款",
  [WalletCategory.OperatorCollect]: "營運商歸集",
  [WalletCategory.OperatorExpend]: "營運商雜支",
  [WalletCategory.TenantReceive]: "商戶收款",
  [WalletCategory.TenantCollect]: "商戶歸集",
  [WalletCategory.TenantExpend]: "商戶雜支",
  [WalletCategory.TenantBrokerReceive]: "商戶代理收款",
  [WalletCategory.TenantBrokerCollect]: "商戶代理歸集",
  [WalletCategory.TenantBrokerExpend]: "商戶代理雜支",
  [WalletCategory.TenantMemberReceive]: "商戶會員收款",
  [WalletCategory.TenantMemberCollect]: "商戶會員歸集",
  [WalletCategory.TenantMemberExpend]: "商戶會員雜支",
  [WalletCategory.External]: "未受管理",
});
